// Icon Builder

<template>
	<div class="main">
		<div class="title wi8_font">Icon Builder</div>

		<div class="t1">Size:</div>
		<button @click="w=36; h=36">36</button>
		<button @click="w=48; h=48">48</button>
		<button @click="w=96; h=96">96</button>
		<button @click="w=128; h=128">128</button>
		<button @click="w=256; h=256">256</button>
		<button @click="w='xx'; h='xx'">Err</button>
		<br/>
		<div class="t1">Fit:</div>
		<button @click="fit=0">Fit 0</button>
		<button @click="fit=1">Fit 1</button>
		<button @click="fit='xxx'">Err</button>
		<br/>
		<div class="t1">Pad:</div>
		<button @click="pad=0">0</button>
		<button @click="pad=5">5</button>
		<button @click="pad=10">10</button>
		<button @click="pad=20">20</button>
		<button @click="pad='xxx'">Err</button>
		<br/>
		<div class="t1">Color:</div>
		<button @click="color='#369'">Blue</button>
		<button @click="color='#C30'">Red</button>
		<button @click="color='#090'">Green</button>
		<button @click="color='xxx'">Err</button>
		<br/>
		<div class="t1">Image:</div>
		<button @click="ico='pic'">Pic</button>
		<button @click="ico='graph'">Graph</button>
		<button @click="ico='ribbon'">Ribbon</button>
		<button @click="ico='write'">Write</button>
		<button @click="ico='logo_da'">DA</button>
		<button @click="ico='xbadx'">Err</button>
		<br/>
		
		<div class="frame">
			<UniIcon 
				:w="w"
				:h="h"
				:fit="fit"
				:pad="pad"
				:color="color"
				:ico="ico"
			/>
		</div>

		<div class="frame" style="padding:10px">
			<div class="t1">Size:</div><div class="t1">{{w}} x {{h}}</div>
			<div class="t1">Fit:</div><div class="t1">{{fit}}</div>
			<div class="t1">Pad:</div><div class="t1">{{pad}}</div>
			<div class="t1">Color:</div><div class="t1">{{color}}</div>
			<div class="t1">Image:</div><div class="t1">{{ico}}</div>

		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			color:	"#090",
			ico:	"home",
			pad:	10,
			fit:	0,
			w:		100,
			h:		100,
		}
	},
}
</script>

<style scoped>
	.main {
		height: 100%;
		background-color: #FCFCEE;
		padding: 5px;
		border: solid 0px #009;
	}
	.title {
		color: #369;
	}
	.t1 {
		display: inline-block;
		width: 60px;
		height: 30px;
		overflow: hidden;
		vertical-align: top;
		border: solid 0px #C30;
	}
	.frame {
		display: inline-block;
		width: 200px;
		height: 200px;
		overflow: hidden;
		border: solid 1px #369;
	}
	button {
		width: 60px;
	}
</style>
